// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"spinner_wrapper__3dV28","spinner":"spinner_spinner__21x4r"};